/**
 * Created by lihanying on 2017/6/30.
 */
import React from 'react'
import { Table, DatePicker, Button, Radio } from 'antd'
import { clickDownload } from '../../../util/index'
import NineAndZeroRadio from '../../../components/nineAndZeroRadio'
import { col_revenue } from '../../../components/CommonTable/columns'
import moment from 'moment'
import './style.css'
import { changeStringTime } from '../../../util'
import { CLUB_ID } from '../../ClubBusiness/constants'
const { RangePicker } = DatePicker

const startD = new Date()
startD.setDate(1)
const nowDate = new Date()
export default class extends React.Component {
  state = {
    loading: false,
    reportPeriod: {
      start_time: moment(startD).format('YYYY-MM-DD'),
      end_time: moment(nowDate).format('YYYY-MM-DD'),
    },
    // radioValue: this.props.statisticType,
    radioValue: 2,
  }

  getDatas = () => {
    const { reportPeriod, radioValue } = this.state
    this.setState({ loading: true })
    const startTime = moment(reportPeriod.start_time).format(
      'YYYY-MM-DD HH:mm:ss'
    )
    const endTime = moment(reportPeriod.end_time).format('YYYY-MM-DD HH:mm:ss')
    this.props
      .fetchClubRevenue({
        club_id: sessionStorage.getItem(CLUB_ID),
        start_time: startTime,
        end_time: endTime,
        statisticType: radioValue,
      })
      .then((res) => {
        this.setState({ loading: false })
      })
  }

  onChange = (value, dateString) => {
    if (value) {
      this.setState({
        reportPeriod: { start_time: dateString[0], end_time: dateString[1] },
      })
    }
  }

  onSubmit = () => {
    this.getDatas()
  }

  onTypeEvent = (type) => {
    this.setState({
      radioValue: type,
    })
  }

  render() {
    const { revenueList } = this.props
    const { loading, reportPeriod } = this.state
    const reportName =
      sessionStorage.getItem('reportName') +
      `${changeStringTime(reportPeriod.start_time)}-${changeStringTime(
        reportPeriod.end_time
      )}`

    const n_col_revenue = col_revenue.map((item) => {
      if (item.dataIndex == 'startTime') {
        item['fixed'] = 'left'
      }
      return item
    })

    return (
      <div>
        <div style={{ marginBottom: '1rem' }}>
          <NineAndZeroRadio typeEvent={this.onTypeEvent} />
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <RangePicker
            format="YYYY-MM-DD"
            placeholder={['开始时间', '结束时间']}
            value={[
              moment(`${reportPeriod.start_time}`, 'YYYY-MM-DD'),
              moment(`${reportPeriod.end_time}`, 'YYYY-MM-DD'),
            ]}
            onChange={this.onChange}
          />
          <Button
            type="primary"
            style={{ marginLeft: '20px' }}
            onClick={() => this.onSubmit()}
          >
            查询
          </Button>
          <Button style={{ marginLeft: '20px' }}>
            <a
              id="test"
              href={clickDownload(n_col_revenue, revenueList || [])}
              download={`${reportName}.csv`}
            >
              导出
            </a>
          </Button>
        </div>
        <Table
          rowKey="id"
          bordered
          loading={loading}
          columns={n_col_revenue}
          dataSource={revenueList || []}
          pagination={false}
          scroll={{
            y: +window.innerHeight - 350,
            x: (n_col_revenue.length - 1) * 200 + 150,
          }}
          size="middle"
          className="revenue_table"
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubRevenueNew/component/revenue.js